import { Tabs } from "@mantine/core"
import { useState } from "react"

import { useListCertificateTypesQuery } from "~/pages/Admin/MasterLists/CertificatesTypes/Standards/hooks"

import { CertificateTypesWrapper } from "./Certiicates"
import { Standards } from "./Standards/Standards"

export const CertificatesTypesAdminWrapper = () => {
  const { data: certificateTypesList } = useListCertificateTypesQuery()
  const [tab, setTab] = useState<string>("standards")

  return (
    <Tabs value={tab} onChange={(value) => setTab(value ? value : "")}>
      <Tabs.List>
        <Tabs.Tab key="standards" value="standards">
          Standards
        </Tabs.Tab>
        <Tabs.Tab key="certificates" value="certificates">
          Certificates
        </Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="standards">
        {tab === "standards" ? (
          <Standards certificatesTypesList={certificateTypesList ?? []} />
        ) : null}
      </Tabs.Panel>
      <Tabs.Panel value="certificates">
        {tab === "certificates" ? <CertificateTypesWrapper /> : null}
      </Tabs.Panel>
    </Tabs>
  )
}
